import { useState } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { useBreadcrumb } from "features/breadcrumbs";
import PageHeader from "components/Page/PageHeader";
import { Col, Row } from "antd";
import DashboardMovimentacoes from "ui/components/RelatorioDemonstrativoReceitaDespesa/DashboardMovimentacoes";
import RelatorioDemonstrativo from "./components/RelatorioDemonstrativo";
import ModalFiltros from "ui/components/Relatorio/ModalFiltros";
import useFiltroRelatorioReceitaDespesa from "./components/RelatorioDemonstrativo/hooks/useFiltroRelatorioReceitaDespesa";
import { useRelatorioDemonstrativoReceitaDespesa } from "core/features/relatorios/hooks/useRelatorioDemonstrativoReceitaDespesa";
import Container from "components/Container";
import DateRangePicker from "components/Input/DateRangePicker";
import { FaFilter } from "react-icons/fa";
import { AiOutlinePlus } from "react-icons/ai";
import ModalDetalhamentoContaCategoria from "components/RelatorioDemonstrativoReceitaDespesa/ModalDetalhamentoContaCategoria";
import { DemonstrativoReceitaEDespesaItem } from "core/features/relatorios/typings";

function DemonstrativoReceitasDespesas() {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { filtro, onChangeFiltro } = useFiltroRelatorioReceitaDespesa();

  const { data, isLoading } = useRelatorioDemonstrativoReceitaDespesa(filtro);

  const [itemDetalhamentoContaCategoria, setItemDetalhamentoContaCategoria] =
    useState<DemonstrativoReceitaEDespesaItem>();

  const numeroFiltroSelecionados =
    (filtro.contaCategoriaIds?.length || 0) +
    (filtro.contaBancariaIds?.length || 0);

  useBreadcrumb([
    { name: "Relatórios" },
    { name: "Financeiro", url: "/relatorios/financeiro" },
    {
      name: "Demonstrativo de Receitas e Despesas",
      url: "/relatorios/financeiro/receitas-despesas",
    },
  ]);

  return (
    <Container>
      <PageHeader
        title="Demonstrativo de Receitas e Despesas"
        extraButtonTitle="Filtrar"
        extraButtonOnClick={() => setIsOpenModal(true)}
        badge={!!numeroFiltroSelecionados}
        badgeValueExtraButton={numeroFiltroSelecionados}
        midComponent={
          <DateRangePicker
            allowEmptyDates={{
              dataInicio: true,
              dataFim: false,
            }}
            onChange={(dataInicio, dataFim) => {
              onChangeFiltro({
                dataInicio,
                dataFim,
              });
            }}
            value={{
              dataFim: filtro.dataFim,
              dataInicio: filtro.dataInicio,
            }}
          />
        }
        iconExtraButton={
          <>
            <FaFilter size={14} />
            <Flex right="10px" top="14px" position="absolute">
              <AiOutlinePlus size={9} />
            </Flex>
          </>
        }
      />

      <Row gutter={32} align="bottom">
        <Col sm={24} md={24}>
          <DashboardMovimentacoes
            isLoading={isLoading}
            totais={data?.totais}
            dataFim={filtro.dataFim}
          />
        </Col>
      </Row>
      <Box>
        <RelatorioDemonstrativo
          data={data}
          filtro={filtro}
          isLoading={isLoading}
          onChangeFiltro={onChangeFiltro}
          setItemDetalhamentoContaCategoria={setItemDetalhamentoContaCategoria}
        />
      </Box>
      <ModalFiltros
        isOpenModal={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        filtro={filtro}
        onChangeFiltro={onChangeFiltro}
        numeroFiltroSelecionados={numeroFiltroSelecionados}
      />
      <ModalDetalhamentoContaCategoria
        isOpenModal={!!itemDetalhamentoContaCategoria?.id}
        onClose={() => setItemDetalhamentoContaCategoria(undefined)}
        id={itemDetalhamentoContaCategoria?.id}
        item={itemDetalhamentoContaCategoria}
        params={{
          dataInicio: filtro.dataInicio,
          dataFim: filtro.dataFim,
          contasBancariasIds: filtro.contaBancariaIds,
          centrosDeCustoIds: filtro.centrosDeCustoIds,
        }}
      />
    </Container>
  );
}

export default DemonstrativoReceitasDespesas;
